import React from 'react';
import { FaTimes, FaBars } from 'react-icons/fa';
import styled from 'styled-components';

import MenuNav from './MenuNav';

const AppMenu = ({ logout, isSmallScreen, isLoggedIn, isVerified, hideBalance, setHideBalance }: AppMenuProps) => {
	const [menuOpen, setMenuOpen] = React.useState(false);
	const handleToggleMenu = React.useCallback(() => setMenuOpen((menuOpen) => !menuOpen), []);
	const toggleHideBalance = React.useCallback(() => setHideBalance(!hideBalance), [hideBalance, setHideBalance]);

	return (
		<>
			<MenuGroupButton onClick={handleToggleMenu} isSmallScreen={isSmallScreen}>
				{menuOpen ? (
					<FaTimes size={isSmallScreen ? 24 : 36} />
				) : (
					<div
						style={{
							position: 'relative',
						}}
					>
						<FaBars size={isSmallScreen ? 24 : 36} />
						{isLoggedIn && !isVerified && <AlertDot />}
					</div>
				)}
			</MenuGroupButton>

			{menuOpen && (
				<div style={{ position: 'relative' }}>
					<MenuNav
						hideBalance={hideBalance}
						isSmallScreen={isSmallScreen}
						logout={logout}
						toggleBalance={toggleHideBalance}
						toggleMenu={handleToggleMenu}
						isLoggedIn={isLoggedIn}
						isVerified={isVerified}
					/>
				</div>
			)}
		</>
	);
};

export default AppMenu;

interface AppMenuProps {
	logout: () => void;
	isSmallScreen: boolean;
	isLoggedIn: boolean;
	isVerified: boolean;
	hideBalance: boolean;
	setHideBalance: (hideBalance: boolean) => void;
}

const MenuGroupButton = styled.button<{ isSmallScreen: boolean }>`
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	line-height: 1.25rem;
	margin-left: ${({ isSmallScreen }) => (isSmallScreen ? '10px' : '20px')};
	border-radius: 9999px;
	color: ${({ theme }) => theme.colors.white};

	&:focus {
		outline: none;
	}
`;

const AlertDot = styled.div<{ size?: number }>(({ theme, size = 10 }) => ({
	width: size,
	height: size,
	borderRadius: '100%',
	backgroundColor: 'red',
	position: 'absolute',
	right: -4,
	top: -2,
	borderWidth: 1,
	borderColor: theme.colors.darkGreyR,
}));
